import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class CompensationType extends Enum {
  key!: string;
  value!: string;
  title!: string;

  static ONE_TIME: CompensationType = {
    key: 'one_time',
    get value() {
      return Lang.t('liability.one-time');
    },
    get title() {
      return Lang.t('liability.compensation-one-time');
    }
  };

  static RECURRING: CompensationType = {
    key: 'recurring',
    get value() {
      return Lang.t('guidancestep.recurring');
    },
    get title() {
      return Lang.t('liability.compensation-recurring');
    }
  };
}
